import roles from '@/apis/coreIAM/roles'
import { rolesTypes } from '@/store/mutationTypes'

export default {
    state: {
        all: null,
        current: null,
        fetchAll: {
            pending: false,
            error: null
        },
        fetchOne: {
            pending: false,
            error: null,
        },
        createOne: {
            pending: false,
            error: null,
        },
        updateOne: {
            pending: false,
            error: null,
        },
        deleteOne: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [rolesTypes.FETCH_ALL_REQUEST]: function (state) {
            state.fetchAll.pending = true;
        },
        [rolesTypes.FETCH_ALL_SUCCESS]: function (state, roles) {
            state.fetchAll.error = null;
            state.all = roles;
            state.fetchAll.pending = false;
        },
        [rolesTypes.FETCH_ALL_FAILURE]: function (state, error) {
            state.all = null;
            state.fetchAll.error = error;
            state.fetchAll.pending = false;
        },
        [rolesTypes.FETCH_ONE_REQUEST]: function (state) {
            state.fetchOne.pending = true;
        },
        [rolesTypes.FETCH_ONE_SUCCESS]: function (state) {
            state.fetchOne.error = null;
            state.fetchOne.pending = false;
        },
        [rolesTypes.FETCH_ONE_FAILURE]: function (state, error) {
            state.fetchOne.error = error;
            state.fetchOne.pending = false;
        },
        [rolesTypes.CREATE_ONE_REQUEST]: function (state) {
            state.createOne.pending = true;
        },
        [rolesTypes.CREATE_ONE_SUCCESS]: function (state) {
            state.createOne.error = null;
            state.createOne.pending = false;
        },
        [rolesTypes.CREATE_ONE_FAILURE]: function (state, error) {
            state.createOne.error = error;
            state.createOne.pending = false;
        },
        [rolesTypes.UPDATE_ONE_REQUEST]: function (state) {
            state.updateOne.pending = true;
        },
        [rolesTypes.UPDATE_ONE_SUCCESS]: function (state) {
            state.updateOne.error = null;
            state.updateOne.pending = false;
        },
        [rolesTypes.UPDATE_ONE_FAILURE]: function (state, error) {
            state.updateOne.error = error;
            state.updateOne.pending = false;
        },
        [rolesTypes.DELETE_ONE_REQUEST]: function (state) {
            state.deleteOne.pending = true;
        },
        [rolesTypes.DELETE_ONE_SUCCESS]: function (state) {
            state.deleteOne.error = null;
            state.deleteOne.pending = false;
        },
        [rolesTypes.DELETE_ONE_FAILURE]: function (state, error) {
            state.deleteOne.error = error;
            state.deleteOne.pending = false;
        },
    },
    actions: {
        async fetchAll({ commit }) {
            commit(rolesTypes.FETCH_ALL_REQUEST)
            return new Promise((resolve, reject) => {
                roles
                    .fetchAll()
                    .then((roles) => {
                        commit(rolesTypes.FETCH_ALL_SUCCESS, roles.data);
                        resolve(roles.data);
                    })
                    .catch((error) => {
                        commit(rolesTypes.FETCH_ALL_FAILURE, error);
                        reject(error);
                    })
            })
        },
        async fetchOne({ commit }, payload) {
            commit(rolesTypes.FETCH_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                roles
                    .fetchOne(payload.roleUuid)
                    .then((role) => {
                        commit(rolesTypes.FETCH_ONE_SUCCESS)
                        resolve(role.data)
                    })
                    .catch((error) => {
                        commit(rolesTypes.FETCH_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOne({ commit }, payload) {
            commit(rolesTypes.CREATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                roles
                    .createRole(payload.name, payload.description)
                    .then((role) => {
                        commit(rolesTypes.CREATE_ONE_SUCCESS)
                        resolve(role.data)
                    })
                    .catch((error) => {
                        commit(rolesTypes.CREATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOne({ commit }, payload) {
            commit(rolesTypes.UPDATE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                roles
                    .updateRole(payload.roleUuid, payload.name, payload.description)
                    .then((role) => {
                        commit(rolesTypes.UPDATE_ONE_SUCCESS)
                        resolve(role.data)
                    })
                    .catch((error) => {
                        commit(rolesTypes.UPDATE_ONE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async deleteOne({ commit }, payload) {
            commit(rolesTypes.DELETE_ONE_REQUEST)
            return new Promise((resolve, reject) => {
                roles
                    .deleteRole(payload.roleUuid)
                    .then(() => {
                        commit(rolesTypes.DELETE_ONE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(rolesTypes.DELETE_ONE_FAILURE)
                        reject(error)
                    })
            })
        },
    },
}